import { unionBy } from 'lodash';
import AudiencesCRUDActions from '../actions/AudiencesCRUDActions';
import { AudienceDetailsContacts } from '../interfaces/audiences';

export type ContactByAudienceIdStateType = {
  records: Record<number, AudienceDetailsContacts>;
  invalidRecords: Record<number, boolean>;
};

const initial = {
  records: {},
  invalidRecords: {},
};

export const contactsByAudienceId = (
  state: ContactByAudienceIdStateType = initial,
  action: any,
) => {
  switch (action.type) {
    case AudiencesCRUDActions.getAudienceContacts: {
      const {
        audienceId,
        pageNumber,
        entity,
        showPageContacts,
      }: {
        audienceId: number;
        entity: AudienceDetailsContacts;
        pageNumber?: number;
        showPageContacts?: boolean;
      } = action;

      const storeAudienceContacts = state.records[audienceId]?.contacts || [];
      const updatedAudienceContacts =
        pageNumber && !showPageContacts
          ? unionBy(storeAudienceContacts, entity.contacts, 'id')
          : entity.contacts;

      return {
        ...state,
        records: {
          ...state.records,
          [audienceId]: {
            contacts: updatedAudienceContacts,
            pagination: entity.pagination,
          },
        },
        invalidRecords: {
          ...state.invalidRecords,
          [audienceId]: false,
        },
      };
    }
    case AudiencesCRUDActions.updateAction: {
      return {
        ...state,
        invalidRecords: { ...state.invalidRecords, [action.entity.id]: true },
      };
    }
    default:
      return state;
  }
};
